export default [
	{
		title: 'Inicio',
		route: 'dashboard',
		permission: 'Dashboard',
	},
]
